// extracted by mini-css-extract-plugin
export default {"incentivisedBadgeContainer":"a9qZV","incentivisedText":"lUqo2"};